export default __webpack_public_path__ + "img/trending_bottom1.133c48c9.jpg";